import BaseApi from './base'
import config from '../../config'

export default class AdaptiveTestBattle extends BaseApi {
  /**
   * Gets the public user name for the current, logged in user
   * @returns {Promise<AxiosResponse<T>>}
   */
  addToBattle() {
    return this.axios
      .get(config.apiUrl + `/adaptive_test_battle/add_to_adaptive_battle/`)
      .then(({ data }) => {
        return data
      })
  }

  removeUserFromQueue() {
    return this.axios
      .get(
        config.apiUrl +
          '/adaptive_test_battle/remove_from_adaptive_battle_queue/'
      )
      .then(({ data }) => {
        return data
      })
  }

  getBattleStartStatus() {
    return this.axios
      .get(config.apiUrl + `/adaptive_test_battle/is_adaptive_battle_started/`)
      .then(({ data }) => {
        return data
      })
  }

  getHighScore() {
    return this.axios
      .get(config.apiUrl + `/adaptive_test_battle/find_battle_highscore/`)
      .then(({ data }) => {
        return data.map((item, index) => {
          item.rank = index + 1

          return item
        })
      })
  }

  getRelativeRank() {
    return this.axios
      .get(config.apiUrl + `/adaptive_test_battle/find_relative_battle_rank/`)
      .then(({ data }) => {
        return data
      })
  }

  getUserStatistics() {
    return this.axios
      .get(`${config.apiUrl}/adaptive_test_battle/find_battle_statistics`)
      .then(({ data }) => {
        return data
      })
  }

  getQueue() {
    return this.axios
      .get(config.apiUrl + `/adaptive_test_battle/get_queue/`)
      .then(({ data }) => {
        return data
      })
  }

  getLatestBattleResult() {
    return this.axios
      .get(
        config.apiUrl +
          `/adaptive_test_battle/find_latest_adaptive_battle_result/`
      )
      .then(({ data }) => {
        return data
      })
  }
}
